import { Transaction } from '@aloft/toolkit-shared';

import { CompTransactions } from './types.ts';

/** @deprecated - Use transaction selectors instead  */
export const createCompTransactionsFromTransactions = (
  comps: Record<string, Transaction>,
  compSequence: string[],
): CompTransactions =>
  Object.fromEntries(
    compSequence.map((propID) => {
      const comp = comps[propID];

      return [
        propID,
        {
          listingStatus: comp?.status,
          contractMonth: comp?.contractDate,
          closeMonth: comp?.saleDate,
          expirationDate: comp?.expirationDate,
          withdrawalDate: comp?.withdrawalDate,
        },
      ];
    }),
  );
